// ProjectDetails.js
import { BorderColorOutlined, ContentCopy, Terminal } from '@mui/icons-material';
import { Autocomplete, Box, Button, Chip, TextField, Tooltip } from '@mui/material';
import { filter, find, isEmpty, lowerCase } from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_SLUGS } from '../../constants';
import useFetch from '../../hooks/http/useFetch';
import { useBreadcrumbState } from '../../store/breadcrumbState';
import ModalWrapper from '../common/modal/wrapper';
import TruncatedScrollingText from '../common/truncatedScrollingText';
import ApiEnvironmentInsights from '../dashboard/widgetLibrary/apiEnvironmentInsights';
import EnvironmentsTable from '../management/ViewEnvironments/EnvironmentsTable';
import AddProjectForm from '../projects/AddProject/AddProjectForm';
import SplitButton from "../common/tree/button";
import LinkProjectToJira from './LinkProjectToJira';
import CommonPopper from '../common/commonPopper';
import copy from 'copy-to-clipboard';
import { IAlertState, useAlertState } from '../../store/alertState';

var format = require("string-template")

const ProjectDetails: FC<any> = ({ project, index, allowRedirect = true }) => {
    const {
        data: assetsData,
    } = useFetch(format(API_SLUGS.ASSETS, { projectId: project?.id }));
    const search = useLocation().search;
    const defaultAssetId = new URLSearchParams(search).get('assetid');
    const [selectedAssetId, setSelectedAssetId] = useState<string | null>(null)
    const { setMessage } = useAlertState((state) => state) as IAlertState;
    const selectedGroup = useBreadcrumbState((state) =>
        //@ts-ignore
        state.selectedGroup)
    const selectedProject = useBreadcrumbState((state) =>
        //@ts-ignore
        state.selectedProject)

    useEffect(() => {
        if (defaultAssetId) {
            setSelectedAssetId(defaultAssetId)
        }
    }, [defaultAssetId])
    return (
        <div className="project-details-block">
            {project ? (

                <Box sx={{ pl: 2 }}>
                    <Box sx={{ display: "flex", justifyContent: "start", mt: 3, mb: 1 }}>


                        <TruncatedScrollingText
                            name={project?.name}
                            typographyVariant='h5'
                            sx={{ textAlign: "left", fontSize: "1.25em", mt: 0.5 }}
                            labelSX={{ mt: 1.5 }}
                            onClick={() => window.open(`/projects/${project.id}`)}
                            labels={project?.labels}
                        />

                        
                                    <Tooltip title="ID">
                                      <CommonPopper
                                        elevatePopper
                                        placement={'bottom-start'}
                                        trigger={
                                        <Chip
                                          className="hand"
                                          size="small"
                                          label="ID"
                                          sx={{ml: 1, mt: 1}}
                                        />}
                                        child={
                                          <Box sx={{ p: 2 }}>
                                            <Tooltip title="Click to copy"
                                            PopperProps={{
                                                modifiers: [
                                                  {
                                                    name: 'zIndex',
                                                    enabled: true,
                                                    phase: 'write',
                                                    fn({ state }) {
                                                      state.styles.popper.zIndex = '99999';
                                                    },
                                                  },
                                                ],
                                              }}
                                            ><pre className="hand" onClick={() => {
                                              copy(project?.id);
                                              setMessage({
                                                title: "Project ID is copied to the clipboard",
                                                type: "success",
                                              });
                                            }}><ContentCopy fontSize="inherit" />
                                              {project?.id
                                              } </pre>
                                            </Tooltip>
                                          </Box>
                                        }
                                        />
                                        </Tooltip>
                                        

                        <ModalWrapper
                            maxWidth="lg"
                            title={`Edit ${project?.name}`}
                            trigger={
                                <Chip
                                    size="small"
                                    color="primary"
                                    variant="outlined"

                                    icon={<Tooltip title="Edit"><BorderColorOutlined /></Tooltip>}


                                    sx={{ border: "none", mt: 1, ml: 1 }}
                                    onClick={() => { }}
                                />
                            }
                            child={<AddProjectForm

                                defaultFormValues={{
                                    project: project?.name,
                                }}
                                callback={() => {
                                    window.location.reload()
                                }}
                                groupId={
                                    //@ts-ignore
                                    selectedGroup?.id}
                                updateOnly
                                defaultAllowEdit={true}
                                defaultAllowDelete={true}

                                updateUUID={project.id}
                            />}
                        />
                        <ModalWrapper
                            maxWidth="lg"
                            title={`Environments - ${project?.name}`}
                            trigger={
                                <Chip
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                    icon={<Tooltip title="Environments"><Terminal /></Tooltip>}


                                    sx={{ border: "none", mt: 1 }}
                                    onClick={() => { }}
                                />
                            }
                            child={<EnvironmentsTable projectId={project.id} />}
                        />

                        <ModalWrapper
                            maxWidth="sm"
                            title={project?.jira?.details?.serverId ? 'Jira Details' : 'Link To Jira'}
                            trigger={
                                <Button
                                size="small"
                                sx={{ mr: 1, py:0, height: '2em', mt: 1}}
                                variant={project?.jira?.details?.serverId ? 'contained' : 'outlined'}
                              >
                                 {project?.jira?.details?.serverId ? 'Jira Details' : 'Link To Jira'}
                              </Button>
                            }
                            child={<LinkProjectToJira projectId={project?.id} />}
                        />

                       

                    </Box>
                   <Box sx={{display: "flex", justifyContent: "start"}}> 
                    {!isEmpty(assetsData?.assets) && <Autocomplete
                        key={`selector-${defaultAssetId}`}
                        sx={{ maxWidth: "20em", textAlign: "left", flex: 1, mr: 1 }}
                        size="small"
                        getOptionLabel={(option: any) => option?.name}
                        options={assetsData?.assets || []}
                        onChange={(e, value: any) => {

                            if (value?.id) {
                                setSelectedAssetId(value?.id)
                                // window.open(`/projects/${project?.id}?assetid=${value?.id}`, "_self")
                                window.history.replaceState(null, "New Page Title", `/projects/${project?.id}?assetid=${value?.id}`)
                            } else {
                                setSelectedAssetId(null)
                                window.history.replaceState(null, "New Page Title", `/projects/${project?.id}`)
                                // window.open(`/projects/${project?.id}`, "_self")
                            }
                        }}
                        value={find(assetsData?.assets, { id: selectedAssetId })}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, function (item: any) {
                                return lowerCase(item.name).indexOf(lowerCase(params.inputValue)) > -1;
                            });

                            return filtered;
                        }}
                        renderInput={(params): JSX.Element => {
                            return (
                                <TextField
                                    autoComplete="off"
                                    name="id"
                                    variant="outlined"
                                    label="Select Asset"
                                    {...params}
                                />
                            );
                        }}
                    />}
                     <SplitButton sx={{ m: 0, pb: 0 }} groupId={selectedGroup?.id} disableAddProject={true} projectId={selectedProject?.id}/>
                    </Box>
                    <ApiEnvironmentInsights
                        projectId={project?.id}
                        project={project}
                        assetId={selectedAssetId}

                    />
                </Box>

            ) : (
                <p>Select a project to view details.</p>
            )}
        </div>
    );
}

export default ProjectDetails;
